import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    .overflow--hidden {
        overflow: hidden !important;
    }
`;
